import { render, staticRenderFns } from "./Content.vue?vue&type=template&id=1a789840&scoped=true";
import script from "./Content.vue?vue&type=script&lang=js";
export * from "./Content.vue?vue&type=script&lang=js";
import style0 from "./Content.vue?vue&type=style&index=0&id=1a789840&prod&lang=less&scoped=true";

/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js";
var component = normalizer(script, render, staticRenderFns, false, null, "1a789840", null);
export default component.exports;